import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min'
import ScanSuccess from './ScanSuccess';
import OutZone from './OutZone.jsx';
import FormScan from './FormScan.jsx';
import ScanAgain from './ScanAgain.jsx';
import ScanQRCode from './ScanQrCode.jsx';

export default function Index() {
      const { url } = useRouteMatch();
      return (<Switch>
            <Route path={`${url}/scan-qrcode`} component={ScanQRCode} />
            <Route path={`${url}/:code/form-success`} component={ScanSuccess} />
            <Route path={`${url}/:code/out-of-zone`} component={OutZone} />
            <Route path={`${url}/:code/scan-again`} component={ScanAgain} />
            <Route path={`${url}/:code`} component={FormScan} />
      </Switch>)
}
